<script setup lang="ts">

import BaseContainer from "@/core/components/base/BaseContainer.vue";
import {onMounted, ref} from "vue";
import {NotificationSequence} from "@/notification-sequences/interfaces/NotificationSequence";
import {notificationSequenceApi} from "@/container";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {NotificationSequenceCard} from "@/notification-sequences/components/notification-sequence-card";
import {Info, GitCommitVertical} from "@lucide/vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import {useRouter} from "vue-router";

const router = useRouter();

const loading = ref<boolean>();
const sequences = ref<NotificationSequence[]>();

onMounted(() => {
    loading.value = true;
    notificationSequenceApi().index({
        types: ['program', 'company', 'laboratory']
    })
        .then((response) => {
            sequences.value = response;
        })
        .finally(() => {
            loading.value = false;
        });
});

const navigate = (sequence: NotificationSequence) => {
    router.push({name: 'patient-administration.communication.sequences.details', params: {sequenceId: sequence.id}});
};
</script>

<template>
  <BaseContainer class="flex flex-col gap-4 p-4">
    <h1>Communiquez auprès de vos patients</h1>
    <div class="bg-white border rounded-lg px-3 py-2 flex items-center gap-3">
      <Info class="size-5 inline-flex text-primary shrink-0" />
      <span
        class="leading-none text-sm text-muted-foreground"
      >
        Quand un patient achète un produit défini, il reçoit automatiquement un message - sans action de votre part.
      </span>
    </div>
    <BaseFlexSpinner v-if="loading" />
    <BaseCard v-else-if="!sequences?.length">
      <BaseCardBody class="flex flex-col items-center text-center gap-4">
        <div class="p-6 bg-lightPurple-lightest rounded-xl">
          <GitCommitVertical class="text-primary size-12" />
        </div>
        <h1>Aucune séquence disponible</h1>
      </BaseCardBody>
    </BaseCard>
    <div v-else class="flex flex-col gap-4">
      <NotificationSequenceCard
        v-for="sequence in sequences"
        :key="sequence.id"
        :sequence="sequence"
        color="primary"
        @navigate="navigate"
      />
    </div>
  </BaseContainer>
</template>

<style scoped>

</style>
